// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IAuditLogChangesetInfoDto
 */
export interface IAuditLogChangesetInfoDto {
    /**
     * 
     * @type {number}
     * @memberof IAuditLogChangesetInfoDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IAuditLogChangesetInfoDto
     */
    entity_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IAuditLogChangesetInfoDto
     */
    entity_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IAuditLogChangesetInfoDto
     */
    changed_by_name?: string;
    /**
     * 
     * @type {Date}
     * @memberof IAuditLogChangesetInfoDto
     */
    changed_at?: Date;
    /**
     * 
     * @type {string}
     * @memberof IAuditLogChangesetInfoDto
     */
    update_source?: IAuditLogChangesetInfoDtoUpdateSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof IAuditLogChangesetInfoDto
     */
    action_type?: IAuditLogChangesetInfoDtoActionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IAuditLogChangesetInfoDto
     */
    changes_count?: number;
    /**
     * 
     * @type {string}
     * @memberof IAuditLogChangesetInfoDto
     */
    actor_type?: IAuditLogChangesetInfoDtoActorTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IAuditLogChangesetInfoDto
     */
    source_entry_point?: string;
}

/**
* @export
* @enum {string}
*/
export enum IAuditLogChangesetInfoDtoUpdateSourceEnum {
    FILE = 'FILE',
    API = 'API',
    ADMIN_PORTAL = 'ADMIN_PORTAL',
    USER_PORTAL = 'USER_PORTAL'
}
/**
* @export
* @enum {string}
*/
export enum IAuditLogChangesetInfoDtoActionTypeEnum {
    CREATE = 'CREATE',
    UPDATE = 'UPDATE',
    DELETE = 'DELETE',
    UPDATE_FROM_HIERARCHY = 'UPDATE_FROM_HIERARCHY'
}
/**
* @export
* @enum {string}
*/
export enum IAuditLogChangesetInfoDtoActorTypeEnum {
    ADMIN = 'ADMIN',
    EMPLOYEE = 'EMPLOYEE',
    PARTNER_USER = 'PARTNER_USER',
    FILE = 'FILE',
    SYSTEM = 'SYSTEM'
}


/**
 * Check if a given object implements the IAuditLogChangesetInfoDto interface.
 */
export function instanceOfIAuditLogChangesetInfoDto(value: object): value is IAuditLogChangesetInfoDto {
    return true;
}

export function IAuditLogChangesetInfoDtoFromJSON(json: any): IAuditLogChangesetInfoDto {
    return IAuditLogChangesetInfoDtoFromJSONTyped(json, false);
}

export function IAuditLogChangesetInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAuditLogChangesetInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'entity_name': json['entity_name'] == null ? undefined : json['entity_name'],
        'entity_id': json['entity_id'] == null ? undefined : json['entity_id'],
        'changed_by_name': json['changed_by_name'] == null ? undefined : json['changed_by_name'],
        'changed_at': json['changed_at'] == null ? undefined : (new Date(json['changed_at'])),
        'update_source': json['update_source'] == null ? undefined : json['update_source'],
        'action_type': json['action_type'] == null ? undefined : json['action_type'],
        'changes_count': json['changes_count'] == null ? undefined : json['changes_count'],
        'actor_type': json['actor_type'] == null ? undefined : json['actor_type'],
        'source_entry_point': json['source_entry_point'] == null ? undefined : json['source_entry_point'],
    };
}

export function IAuditLogChangesetInfoDtoToJSON(json: any): IAuditLogChangesetInfoDto {
    return IAuditLogChangesetInfoDtoToJSONTyped(json, false);
}

export function IAuditLogChangesetInfoDtoToJSONTyped(value?: IAuditLogChangesetInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'entity_name': value['entity_name'],
        'entity_id': value['entity_id'],
        'changed_by_name': value['changed_by_name'],
        'changed_at': value['changed_at'] == null ? undefined : ((value['changed_at']).toISOString()),
        'update_source': value['update_source'],
        'action_type': value['action_type'],
        'changes_count': value['changes_count'],
        'actor_type': value['actor_type'],
        'source_entry_point': value['source_entry_point'],
    };
}

